import { extract } from '../extractors/holders';

const txt = (lang, zh, en) => (lang === 'en' ? en : zh);

export function buildHtml(project, a, lang = 'zh') {
  const d = extract(project, a);
  if (!d || d.holders.length === 0) return '';
  const rows = d.holders.slice(0, 10).map((h, i) => `
    <tr style="border-bottom:1px solid #f3f4f6">
      <td style="padding:5px 8px;font-size:11px">${i + 1}</td>
      <td style="padding:5px 8px;font-family:monospace;font-size:10px">${h.label || (h.address ? h.address.slice(0, 6) + '…' + h.address.slice(-4) : '—')}</td>
      <td style="padding:5px 8px;text-align:right;font-weight:600;font-size:11px">${h.percent != null ? h.percent.toFixed(2) + '%' : '—'}</td>
    </tr>`).join('');
  return `
<div style="border:1px solid #e5e7eb;border-radius:10px;overflow:hidden;margin-bottom:14px">
  <div style="padding:13px 16px;background:#fafafa;border-bottom:1px solid #f3f4f6;font-size:13px;font-weight:800;color:#111827">
    👥 ${txt(lang, '前10持有者浓度', 'Top 10 Holder Concentration')}
    <span style="margin-left:8px;font-weight:400;font-size:10px;color:#94a3b8">Surf · ${d.chain || '—'}</span>
  </div>
  <table style="width:100%;font-size:11px;border-collapse:collapse">
    <thead><tr style="background:#f9fafb">
      <th style="padding:5px 8px;text-align:left;color:#6b7280;font-size:10px">#</th>
      <th style="padding:5px 8px;text-align:left;color:#6b7280;font-size:10px">${txt(lang, '地址 / 标签', 'Address / Label')}</th>
      <th style="padding:5px 8px;text-align:right;color:#6b7280;font-size:10px">%</th>
    </tr></thead>
    <tbody>${rows}</tbody>
  </table>
</div>`;
}
